export function startRenderStatus() {
  const target = document.querySelector("#render-status-content");
  const button = document.querySelector("#render-status-refresh");
  const incompleteOnly = document.querySelector("#render-incomplete-only");
  if (!target || !button) return;

  let busy = false;
  function applyFilter() {
    for (const row of target.querySelectorAll(".render-depth")) {
      row.hidden = Boolean(incompleteOnly?.checked && row.dataset.complete === "true");
    }
  }
  async function refresh() {
    if (busy || document.hidden) return;
    busy = true;
    button.disabled = true;
    try {
      const response = await fetch(target.dataset.fragmentUrl, { credentials: "same-origin", cache: "no-store" });
      if (!response.ok) throw new Error(response.status === 404 ? "Your admin session has ended. Open your private admin link again." : "Could not refresh the rendering status.");
      const openDepths = new Set([...target.querySelectorAll(".render-depth[open]")].map((item) => item.dataset.depth));
      const openProfile = new Set([...target.querySelectorAll("[data-profile-key][open]")].map((item) => item.dataset.profileKey));
      // This is a same-origin, server-rendered fragment with escaped template values.
      const fragment = new DOMParser().parseFromString(await response.text(), "text/html");
      target.replaceChildren(...fragment.body.childNodes);
      for (const item of target.querySelectorAll(".render-depth")) item.open = openDepths.has(item.dataset.depth);
      for (const item of target.querySelectorAll("[data-profile-key]")) item.open = openProfile.has(item.dataset.profileKey);
      applyFilter();
      document.querySelector("#render-status-error")?.remove();
    } catch (error) {
      let notice = document.querySelector("#render-status-error");
      if (!notice) {
        notice = document.createElement("p");
        notice.id = "render-status-error";
        notice.className = "render-notice render-notice--error";
        notice.setAttribute("role", "status");
        target.before(notice);
      }
      notice.textContent = error.message;
    } finally {
      busy = false;
      button.disabled = false;
    }
  }

  button.addEventListener("click", refresh);
  incompleteOnly?.addEventListener("change", applyFilter);
  applyFilter();
  document.addEventListener("visibilitychange", () => { if (!document.hidden) refresh(); });
  window.setInterval(refresh, 15_000);
}
